import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  Typography,
} from "@mui/material";
import React from "react";
import CommonButton from "../../../../component/Button";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import ExclamatoryIco from "../../../../assets/icons/ExclamatoryIco";
import { CustomizeSpan } from "../../style";
import { CustomDiv } from "../../../chat-bot/style";

export default function Review({
  review,
  handleClose,
  matchedData,
  negative_flag,
  handleMarkAsReviewed,
}) {
  console.log(review, "sfslkfsjkfskjfnkjsfnjk");
  return (
    <Dialog
      fullWidth
      maxWidth={"md"}
      open={review.open}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
        },
      }}
    >
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Typography variant="h3" marginLeft={"1.1rem"}>
          Review Profile Alerts
        </Typography>
        <Button onClick={handleClose}>
          <XCloseIco />
        </Button>
      </DialogActions>

      <DialogContent style={{ textAlign: "center", paddingTop: "10px" }}>
        <CommonGrid2 display={"flex"} gap={"1rem"} container>
          {negative_flag.map((item) => (
            <CommonGrid2
              item
              size={12}
              borderRadius={"10px"}
              padding={"10px"}
              background="#F7F8F9"
              gap={"10px"}
              alignItems={"start"}
              display={"flex"}
            >
              <CustomDiv>
                <ExclamatoryIco />
              </CustomDiv>
              <Typography variant="body4" color="#00144A" textAlign={"left"}>
                <CustomizeSpan fontWeight={700}>{item.name}</CustomizeSpan> :{" "}
                {item.flag_text}
              </Typography>
            </CommonGrid2>
          ))}
        </CommonGrid2>

        {!matchedData?.insights?.feedback?.is_red_flags_reviewed && (
          <Grid2
            marginTop={"2rem"}
            display={"flex"}
            justifyContent={"end"}
            alignItems={"center"}
            gap={"1rem"}
          >
            <CommonButton
              variant="outlined"
              color="#344054"
              border={"#D0D5DD"}
              fontWeight="600"
              width={"180px"}
              padding={"10px 14px"}
              value="Cancel"
              disabled={review.disabled}
              onClick={handleClose}
            />
            <CommonButton
              variant="contained"
              color="white"
              width={"180px"}
              background="#7F56D9"
              fontWeight="600"
              padding={"10px 14px"}
              disabled={review.disabled}
              loading={review.markLoading}
              value="Mark as reviewed"
              onClick={handleMarkAsReviewed}
            />
          </Grid2>
        )}
      </DialogContent>
    </Dialog>
  );
}
